// extracted by mini-css-extract-plugin
module.exports = {"optionInput":"Forms_optionInput__3UCcE","form":"Forms_form__1pI37","textfield":"Forms_textfield__103d2","errortext":"Forms_errortext__nu9yn"};